import { useTranslations } from 'next-intl';
import { Image } from 'components/image';
import cx from 'classnames';
import { getProductName } from '@cat-ecom/common/utils/stringUtils';
import { CatButton, CatHeading, CatModal } from 'components/blocks-components';
import { getFamilyName } from 'services/equipment/utils';
import { MyEquipmentList } from '../types';
import styles from './my-equipment-modal.module.scss';

export interface DeleteModalProps {
  isOpen: boolean;
  equipmentDetails: MyEquipmentList;
  closeModal: () => void;
  deleteActionHandler: () => void;
}

const DeleteModal = ({
  isOpen,
  equipmentDetails,
  closeModal,
  deleteActionHandler
}: Readonly<DeleteModalProps>) => {
  const t = useTranslations();

  const familyName = getFamilyName(
    equipmentDetails?.model,
    equipmentDetails?.name ?? equipmentDetails?.productFamily
  );
  const equipmentName = `${equipmentDetails?.model} ${getProductName(familyName)}`;
  const modelVariant = equipmentDetails?.assetName ? 'footnote' : 'display-sm';
  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    closeModal();
  };

  return (
    <CatModal
      isActive={isOpen}
      heading={t('DELETE_EQUIPMENT')}
      size="sm"
      onClick={(e) => handleClick(e)}
      returnFocusOnDeactivate={false}
    >
      <CatHeading variant="body-sm">
        <p className={styles['modal-description']}>
          {t('DELETE_WIDGET_HEADER')}
        </p>
      </CatHeading>
      <div className="d-flex align-items-center pb-2 mb-2">
        <Image
          src={`${equipmentDetails?.imageURL}`}
          loading="lazy"
          alt="image banner"
          width={74}
          height={44}
          fit="fit"
        />
        <div className={styles['equipment-content']}>
          <CatHeading variant="display-sm">
            <span className={styles['equipment-name']}>
              {equipmentDetails?.assetName}
            </span>
          </CatHeading>
          <CatHeading variant={modelVariant}>
            <p
              className={cx({
                'm-0': equipmentDetails?.assetName,
                [styles['equipment-name']]: !equipmentDetails?.assetName
              })}
            >
              {equipmentName}
            </p>
          </CatHeading>
          <CatHeading variant="footnote">
            <p className="m-0">{equipmentDetails?.serialNumber}</p>
          </CatHeading>
        </div>
      </div>
      <div slot="footer" className="d-flex gap-2">
        <CatButton variant="danger" onClick={() => deleteActionHandler()}>
          {t('DELETE_WISHLIST')}
        </CatButton>
        <CatButton onClick={() => closeModal()}>{t('CANCEL')}</CatButton>
      </div>
    </CatModal>
  );
};

export default DeleteModal;
